export const sampleData = [
  { id: 1, name: "Night", email: "nightprogrammer95@gmail.com" },
  { id: 2, name: "Gautam", email: "mailgautam@test.com" },
  { id: 3, name: "Alex", email: "xalex@testmail.com" },
  { id: 4, name: "Lina", email: "lina@mail.com" },
  { id: 5, name: "Peter", email: "peter.me@test.com" },
];
